import {
  useBrowsePresetApi,
  useCreatePresetMutationApi,
} from '@aibees/shared/api';
import { PresetVisibility } from '@aibees/shared/definition';
import { useEffect } from 'react';
import useTransferListStore from '../../transfer-list/store/transfer-list-store';
import { TableLayoutTemplate } from '../components/table-layout-modifier-dialog';
import { useAdvanceTableContext } from '../context';

export function useCreateDefaultTableLayoutModifierTemplate() {
  const { config } = useAdvanceTableContext();
  const {
    excluded,
    included,
    config: transferListConfig,
  } = useTransferListStore();
  const api = useCreatePresetMutationApi<TableLayoutTemplate>(
    false,
    false,
    true
  );
  const browseApi = useBrowsePresetApi<TableLayoutTemplate>({
    type: config.columnModifierPresetType!,
    name: 'Default Column Template',
  });

  useEffect(() => {
    const isDefaultTemplateMissing = browseApi.data?.empty;

    if (isDefaultTemplateMissing && api.isIdle) {
      api.mutateAsync({
        name: 'Default Column Template',
        type: config.columnModifierPresetType!,
        value: {
          included: included ?? [],
          excluded: excluded ?? [],
          private: true,
          columns: transferListConfig?.items,
          default: true,
        },
        visibility: PresetVisibility.PRIVATE,
      });
    }
  }, [
    browseApi,
    api.isIdle,
    api,
    config.columnModifierPresetType,
    included,
    excluded,
    transferListConfig?.items,
  ]);
}
